import { render, staticRenderFns } from "./main-story-dialog.vue?vue&type=template&id=68cc7128&scoped=true"
import script from "./main-story-dialog.vue?vue&type=script&lang=js"
export * from "./main-story-dialog.vue?vue&type=script&lang=js"
import style0 from "./main-story-dialog.vue?vue&type=style&index=0&id=68cc7128&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68cc7128",
  null
  
)

export default component.exports